/* eslint-disable */
// @generated by protobuf-ts 2.10.0 with parameter use_proto_field_name,ts_nocheck,eslint_disable,long_type_string
// @generated from protobuf file "common/v3/generic/common_enums.proto" (package "fubo.tv.proto.common.v3.generic", syntax proto2)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message fubo.tv.proto.common.v3.generic.DeviceType
 */
export interface DeviceType {
}
/**
 * @generated from protobuf enum fubo.tv.proto.common.v3.generic.DeviceType.DeviceTypeValue
 */
export enum DeviceType_DeviceTypeValue {
    /**
     * @generated from protobuf enum value: console = 0;
     */
    console = 0,
    /**
     * @generated from protobuf enum value: desktop = 1;
     */
    desktop = 1,
    /**
     * @generated from protobuf enum value: phone = 2;
     */
    phone = 2,
    /**
     * @generated from protobuf enum value: player = 3;
     */
    player = 3,
    /**
     * @generated from protobuf enum value: puck = 4;
     */
    puck = 4,
    /**
     * @generated from protobuf enum value: smart_tv = 5;
     */
    smart_tv = 5,
    /**
     * @generated from protobuf enum value: tablet = 6;
     */
    tablet = 6
}
/**
 * @generated from protobuf message fubo.tv.proto.common.v3.generic.DeviceCategory
 */
export interface DeviceCategory {
}
/**
 * @generated from protobuf enum fubo.tv.proto.common.v3.generic.DeviceCategory.DeviceCategoryValue
 */
export enum DeviceCategory_DeviceCategoryValue {
    /**
     * @generated from protobuf enum value: unknown_device_category = 0;
     */
    unknown_device_category = 0,
    /**
     * @generated from protobuf enum value: web = 1;
     */
    web = 1,
    /**
     * @generated from protobuf enum value: mobile_web = 2;
     */
    mobile_web = 2,
    /**
     * @generated from protobuf enum value: iphone = 3;
     */
    iphone = 3,
    /**
     * @generated from protobuf enum value: ipad = 4;
     */
    ipad = 4,
    /**
     * @generated from protobuf enum value: chromecast = 5;
     */
    chromecast = 5,
    /**
     * @generated from protobuf enum value: ipod = 6;
     */
    ipod = 6,
    /**
     * @generated from protobuf enum value: android_phone = 7;
     */
    android_phone = 7,
    /**
     * @generated from protobuf enum value: android_tablet = 8;
     */
    android_tablet = 8,
    /**
     * @generated from protobuf enum value: roku = 9;
     */
    roku = 9,
    /**
     * @generated from protobuf enum value: apple_tv = 10;
     */
    apple_tv = 10,
    /**
     * @generated from protobuf enum value: smart_tv = 11;
     */
    smart_tv = 11,
    /**
     * @generated from protobuf enum value: fire_tv = 12;
     */
    fire_tv = 12,
    /**
     * @generated from protobuf enum value: android_tv = 13;
     */
    android_tv = 13,
    /**
     * @generated from protobuf enum value: xbox = 14;
     */
    xbox = 14
}
/**
 * Used to differentiate events from different system scopes, events that are from same system scope should share same FuboNameSpace value.
 * In schema, FuboNameSpace is also included in package name, e.g. all events defined in package `fubo.tv.proto.services.papi.v3.tracking` have FuboNameSpace value `papi`
 *
 * @generated from protobuf enum fubo.tv.proto.common.v3.generic.FuboNameSpace
 */
export enum FuboNameSpace {
    /**
     * @generated from protobuf enum value: app = 0;
     */
    app = 0,
    /**
     * @generated from protobuf enum value: fanview = 1;
     */
    fanview = 1,
    /**
     * @generated from protobuf enum value: growth = 2;
     */
    growth = 2,
    /**
     * @generated from protobuf enum value: player = 3;
     */
    player = 3,
    /**
     * @generated from protobuf enum value: papi = 4;
     */
    papi = 4,
    /**
     * @generated from protobuf enum value: recommendations = 5;
     */
    recommendations = 5,
    /**
     * @generated from protobuf enum value: subscriptions = 6;
     */
    subscriptions = 6,
    /**
     * @generated from protobuf enum value: vapi = 7;
     */
    vapi = 7
}
/**
 * @generated from protobuf enum fubo.tv.proto.common.v3.generic.PlaybackType
 */
export enum PlaybackType {
    /**
     * @generated from protobuf enum value: unknown_playback_type = 0;
     */
    unknown_playback_type = 0,
    /**
     * @generated from protobuf enum value: live = 1;
     */
    live = 1,
    /**
     * @generated from protobuf enum value: dvr = 2;
     */
    dvr = 2,
    /**
     * @generated from protobuf enum value: dvr_startover = 3;
     */
    dvr_startover = 3,
    /**
     * @generated from protobuf enum value: lookback = 4;
     */
    lookback = 4,
    /**
     * @generated from protobuf enum value: vod = 5;
     */
    vod = 5,
    /**
     * @generated from protobuf enum value: startover = 6;
     */
    startover = 6,
    /**
     * @generated from protobuf enum value: dvr_ai = 7;
     */
    dvr_ai = 7
}
/**
 * @generated from protobuf enum fubo.tv.proto.common.v3.generic.BillingPlatform
 */
export enum BillingPlatform {
    /**
     * @generated from protobuf enum value: unknown_billing_platform = 0;
     */
    unknown_billing_platform = 0,
    /**
     * @generated from protobuf enum value: apple = 1;
     */
    apple = 1,
    /**
     * @generated from protobuf enum value: google = 2;
     */
    google = 2,
    /**
     * @generated from protobuf enum value: recurly = 3;
     */
    recurly = 3,
    /**
     * @generated from protobuf enum value: roku = 4;
     */
    roku = 4
}
/**
 * @generated from protobuf enum fubo.tv.proto.common.v3.generic.ProgramType
 */
export enum ProgramType {
    /**
     * @generated from protobuf enum value: unknown = 0;
     */
    unknown = 0,
    /**
     * @generated from protobuf enum value: series = 1;
     */
    series = 1,
    /**
     * @generated from protobuf enum value: extra = 2;
     */
    extra = 2,
    /**
     * @generated from protobuf enum value: match = 3;
     */
    match = 3,
    /**
     * @generated from protobuf enum value: movie = 4;
     */
    movie = 4,
    /**
     * @generated from protobuf enum value: episode = 5;
     */
    episode = 5,
    /**
     * @generated from protobuf enum value: other = 6;
     */
    other = 6
}
/**
 * @generated from protobuf enum fubo.tv.proto.common.v3.generic.MultiviewLayout
 */
export enum MultiviewLayout {
    /**
     * @generated from protobuf enum value: unknown_multiview_layout = 0;
     */
    unknown_multiview_layout = 0,
    /**
     * @generated from protobuf enum value: single = 1;
     */
    single = 1,
    /**
     * @generated from protobuf enum value: two = 2;
     */
    two = 2,
    /**
     * @generated from protobuf enum value: two_up = 3;
     */
    two_up = 3,
    /**
     * @generated from protobuf enum value: three_up = 4;
     */
    three_up = 4,
    /**
     * @generated from protobuf enum value: four = 5;
     */
    four = 5
}
/**
 * @generated from protobuf enum fubo.tv.proto.common.v3.generic.PaymentMethod
 */
export enum PaymentMethod {
    /**
     * @generated from protobuf enum value: unknown_payment_method = 0;
     */
    unknown_payment_method = 0,
    /**
     * @generated from protobuf enum value: credit_card = 1;
     */
    credit_card = 1,
    /**
     * @generated from protobuf enum value: paypal = 2;
     */
    paypal = 2,
    /**
     * @generated from protobuf enum value: cash_app = 3;
     */
    cash_app = 3,
    /**
     * @generated from protobuf enum value: amazon_pay = 4;
     */
    amazon_pay = 4
}
// @generated message type with reflection information, may provide speed optimized methods
class DeviceType$Type extends MessageType<DeviceType> {
    constructor() {
        super("fubo.tv.proto.common.v3.generic.DeviceType", []);
    }
    create(value?: PartialMessage<DeviceType>): DeviceType {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<DeviceType>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeviceType): DeviceType {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeviceType, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message fubo.tv.proto.common.v3.generic.DeviceType
 */
export const DeviceType = new DeviceType$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeviceCategory$Type extends MessageType<DeviceCategory> {
    constructor() {
        super("fubo.tv.proto.common.v3.generic.DeviceCategory", []);
    }
    create(value?: PartialMessage<DeviceCategory>): DeviceCategory {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<DeviceCategory>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeviceCategory): DeviceCategory {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeviceCategory, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message fubo.tv.proto.common.v3.generic.DeviceCategory
 */
export const DeviceCategory = new DeviceCategory$Type();
